import { render, staticRenderFns } from "./IcoArrowRight.vue?vue&type=template&id=796d48e1"
import script from "./IcoArrowRight.vue?vue&type=script&lang=js"
export * from "./IcoArrowRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports